import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from "../../../models/response/base-response";
import { actions } from "../../actions/actionsWrapper";
import { ePhongNamHocActionTypesIds, IPhongNamHocSelectStart } from "../../action-types/danh-muc/IPhongNamHocActionTypes";

const phongNamHocApi = apiWrapper.phongNamhoc;

export function* phongNamHocSaga(): any {
    yield takeLatest(ePhongNamHocActionTypesIds.LOAD_START, loadWorker)
    yield takeLatest(ePhongNamHocActionTypesIds.SELECT_START, selectWorker)
}
function* loadWorker(): any {

    const res: IBaseResponeModel = yield call([phongNamHocApi, phongNamHocApi.SelectAll])
    if (res.is_success) {
        yield put(actions.danhMucWrapper.phongNamHoc.loadSuccess(res.data))
    } else {
        yield put(actions.danhMucWrapper.phongNamHoc.loadError(res.message || "Không tải được tuần"))
    }
}
function* selectWorker(action: IPhongNamHocSelectStart): any {
    const res: IBaseResponeModel = yield call([phongNamHocApi, phongNamHocApi.Select])
    if (res.is_success) {
        yield put(actions.danhMucWrapper.phongNamHoc.selectSuccess(res.data))
    } else {
        yield put(actions.danhMucWrapper.phongNamHoc.selectError(res.message || "Không tải được tuần"))
    }
}